import React, {useState} from 'react';
import { Dialog,Box} from '@mui/material';
import BtnPrimary from "../../../../../component/PrimaryButton";
import CloseIcon from '@mui/icons-material/Close';
import EmpFormField from '../../../../../component/EmpFormField';
import { getOrgEmployees } from '../../../../../services/globalData';

import { displayFont } from "../../../../../theme";
function ShareExpense({open, setOpen, onClose}) {

  const [employees, setEmployees] = useState([]);

  const employeeOptions = getOrgEmployees()?.map(employee => ({
    value: employee._id,
    name: employee.fname+" "+employee.lname
  }));

  const handleClick = async () => {
   
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width:"49.56rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px -4px rgba(42,29,34,0.16)",
          padding: "1.5rem 1rem",
        }
      }}
    >
        <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <Box sx={{fontWeight: 600, fontFamily: displayFont, fontSize:"1.25rem", lineHeight: 1.3, color:"#2A1D22", width:"90%", textAlign:"center"}}>
                Share Expense
            </Box>
            <CloseIcon 
                fontSize='small' 
                onClick={()=>setOpen(false)} 
                sx={{
                  justifySelf:"end",
                  "&:hover": {
                    cursor: "pointer",
                  },
            }}/>
        </Box>
        <Box sx={{fontSize:"1rem", lineHeight: 1.7,marginTop: "1rem", marginBottom: "0.5rem"}}>
            Add Employee
        </Box>
        <EmpFormField
                type="select"
                value={employees}
                fullwidth
                options={employeeOptions}
                onChange={(e) => setEmployees(e.target.value)}
                row="0.75"
                placeholder="Search Employee Name"
        />
        <Box sx={{display:"flex", justifyContent:"center"}}>
            <BtnPrimary sx={{width:"18.75rem", borderRadius: "8px"}} onClick={handleClick}>
               Add Employee
            </BtnPrimary>
        </Box>
    </Dialog>
  );
}

export default ShareExpense;

